import MainLayout from "../components/shared/MainLayout";
import Hero from "../components/hero/Hero";
import AboutUs from "../components/about/AboutUs";
import Team from "../components/about/Team";

const About = () => {
  return (
    <MainLayout>
      <Hero title="About Us" link="about" />
      <AboutUs />
      <Team />
    </MainLayout>
  );
};

export default About;
